import React, { useCallback, useEffect, useState } from 'react'
import InputTextField from '../../../components/input/inputTextField'
import { SearchOutlined } from '@mui/icons-material'
import FilterSelect from '../../../components/select/filterSelect'
import { Grid, MenuItem, Typography } from '@mui/material'
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { routeName } from '../../../routes/routeName'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api'
import LastestUpdate from './list/lastest-update'
import MostPopular from './list/most-popular'
import { OnlineCourseApi } from '../../../api/cms-online-course/online_course.api'
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import { swalError } from '../../../components/alert/swal'
export default function OnlineCourses() {
    const [search, setSearch] = useState<any>('')
    const [type, setType] = useState<any>('ALL')
    const [typeData, setTypeDate] = useState<any>([])
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const typeLiat = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };

        const res = await OnlineCourseApi.listType(condition);
        const data = res.data
        if (res.status < 300) {
            setTypeDate(data?.data.items)
        }
    }
    useEffect(() => {
        typeLiat()
    }, [])
    return (
        <div>
            <div className="w-full flex justify-end mt-[40px]">
                <Grid container spacing={2} sx={{ justifyContent: 'end' }}>
                    <Grid item xs={12} md={3}>
                        <InputTextField
                            startAdornment={<SearchOutlined />}
                            placeholder={t("ค้นหา")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setSearch(e.target.value)
                            }}
                            value={search || ''}

                        />
                    </Grid>
                    <Grid item xs={12} md={3}>

                        <FilterSelect
                            value={type || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={[{ id_online_course_type: 'ALL', online_course_type: t("ประเภททั้งหมด") }, ...typeData].map((item: any, index: number) => (
                                <MenuItem value={item?.id_online_course_type} key={index + 1}>
                                    {item?.online_course_type}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => { setType(e.target.value) }
                                // handleChangeValueSearch("year", e.target.value)

                            }
                        // style={{
                        //     width:'300px'
                        // }}
                        />
                    </Grid>
                    {/* <ButtonPrimary
                        onClick={() => {
                        }}
                        mode="add"
                        buttonName={'ค้นหา'}
                        btnProps={{
                            width: "100px"
                        }}
                    /> */}
                </Grid>
            </div>
            <LastestUpdate search={search} type={type} />
            <MostPopular search={search} type={type} />

        </div>
    )
}


export function CardOnlineCourses(props: any) {
    const { item, getData } = props
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const handleSubmit = async (is_booked: any) => {
        const body = {
            is_booked: is_booked
        }
        await PublishOnlineCourseApi.bookmark(is_booked === 0 ? true : false, item?.id_online_course).then((res: any) => {
            if (res.status < 300) {
                // swalSuccess('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว')
                // alertActive('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                // handleSubmit()
                // reactToPrintFn()
                getData()

                // }, 'info',)
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })
    }
    return (
        <div style={{
            boxShadow: '0px 0px 7px -2px #1018281A',
            // padding: '16px',
            borderRadius: '16px',
            minHeight: '360px',
            height: '-webkit-fill-available'
        }} onClick={() => {
            window.location.href = routeName.students.OnlineCourseDetail.replace(':id', `${item?.id_online_course}`)
            // navigate(routeName.students.OnlineCourseDetail.replace(':id', `${item?.id_online_course}`))
        }}>
            <div style={{ position: "relative" }}>
                <img src={process.env.REACT_APP_FILE_BASE_API + '/' + item?.cover_file_path} style={{ width: '100%', height: '150px', objectFit: 'cover', objectPosition: 'center' }} />
                <div style={{ position: "absolute", bottom: "10px", right: "10px", background: "#fff", color: item?.online_course_amount === '0.00' ? '#0F9F0C' : '#000', borderRadius: "50px", padding: '0px 5px', textAlign: 'center', fontSize: "10px" }}>
                    {item?.online_course_amount === '0.00' ? t("ฟรี") : item?.online_course_amount}
                </div>
                <div style={{ position: "absolute", top: "10px", right: "10px", zIndex: 99 }}>
                    <BookmarksIcon sx={{ color: item?.bookmark == '1' ? '#FCAF17' : '#fff' }} onClick={(e) => {
                        e.stopPropagation();
                        handleSubmit(item?.bookmark)
                    }} />
                </div>
            </div>
            {/* <ImageLoader id={item?.thesis_book_cover?.id_thesis_book_file} file_type={item?.thesis_book_cover?.file_type} /> */}
            <div className='p-[16px]' style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: '240px' }}>
                <div>
                    <div className='flex justify-between'>
                        <Typography sx={{ color: '#F79009' }}>{item?.online_course_no}</Typography>
                        <Typography sx={{ color: '#828282', size: '10px' }}>{item?.duration_hour ? t("{{hour}} ชั่วโมง", { hour: item?.duration_hour }) : ''} {item?.duration_minute ? t("{{minute}} นาที", { minute: item?.duration_minute }) : ''} </Typography>
                    </div>
                    <Typography sx={{
                        fontWeight: '600', marginTop: '10px',
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: "2",
                        overflow: "hidden",
                    }}>{item?.online_course_name}</Typography>
                    <Typography sx={{
                        fontSize: '12px',
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: "3",
                        overflow: "hidden",
                    }}>{item?.online_course_description}</Typography>
                </div>
                <div>
                    <Typography sx={{ fontWeight: '600', fontSize: '12px' }}>{item?.online_course_teacher}</Typography>
                    <div

                        style={{ background: "#FFFAEB", width: "fit-content", borderRadius: '50px', color: '#B54708', padding: '0px 5px', textAlign: 'center', fontSize: "14px" }}>
                        {item?.online_course_type}
                    </div>
                </div>

            </div>

        </div>
    )
}
